import axios from 'axios';
import API_URL from './baseURL';

const auth = (token) => ({ headers: { Authorization: `Bearer ${token || localStorage.getItem('authToken')}` } });

export const listCrashes = async (token) => {
  const res = await axios.get(`${API_URL}/telematics/crashes`, auth(token));
  return res.data?.data?.crashes || [];
};
export const generateEstimate = async (crashId, token) => {
  const res = await axios.post(`${API_URL}/telematics/crashes/${crashId}/estimate`, {}, auth(token));
  return res.data?.data?.estimate;
};
export const getEstimate = async (crashId, token) => {
  const res = await axios.get(`${API_URL}/telematics/crashes/${crashId}/estimate`, auth(token));
  return res.data?.data?.estimate;
};
export const sendEstimate = async (id, to, token, message = '') => {
  const res = await axios.post(`${API_URL}/telematics/estimates/${id}/send`, { to, message }, auth(token));
  return res.data;
};
